import Vue from 'vue'
import App from './App.vue'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import ElementUI from 'element-ui';

// import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import router from "./router/index"
import VueCookies from 'vue-cookies';
import store from '@/store';
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo)

Vue.component(CollapseTransition.name, CollapseTransition)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.cookie = VueCookies;

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
    // document.dispatchEvent(new Event('custom-render-trigger'))
  }
  
}).$mount('#app')
